
<template>
  <div>
    <v-data-table
      :headers="headers"
      :items-per-page="10"
      :items="comp_done_forms"
      :search="search"
    >
      <template v-slot:top>
        <v-text-field  v-model="search" label="Buscar" class="mx-4"></v-text-field>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-btn small text color="primary" @click="doneFormDialog(item)" rounded outlined>
          <v-icon left>mdi-clipboard-text</v-icon>VER
        </v-btn>

        <v-btn small text color="primary" @click="downloadPdf(item)" rounded outlined class="ml-2">
          <v-icon left>mdi-download</v-icon>PDF
        </v-btn>
      </template>

      <template v-slot:[`item.birthdate`]="{ item }">
        {{ $dayjs().diff($dayjs(item.birthdate).format('YYYY-MM-DD'), 'year' )}} anos
      </template>

      <template v-slot:[`item.country`]="{ item }">
        {{ countries_map[item.country] != null ? countries_map[item.country] : item.country }}
      </template>

      <template v-slot:[`item.status`]="{ item }">
        <v-chip small :color="status_chips_map[item.status].color">
          <v-icon small class="mr-2">{{status_chips_map[item.status].icon}}</v-icon>{{status_chips_map[item.status].title}} 
        </v-chip>
      </template>
    </v-data-table>

    <dialog-enrollment-done-form
      v-if="dialog"
      :dialog="dialog" 
      :selected_done_form="selected_done_form"
      :course_status="course.status"
      @closeDialog="handleCloseDialog" 
      @setDoneFormStatus="handleSetDoneFormStatus"
    />

  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import Api from '@/api/index'

export default {
  name: 'ListCandidates',
  props: {
    course: {
      type: Object,
    },
    done_forms:{
      type: Array,
    }
  },
  components: {
    DialogEnrollmentDoneForm: () => import ('../select_components/DialogEnrollmentDoneForm.vue'),
  },
  data() {
    return {
      // done_forms: [],
      dialog: false,

      selected_done_form: null,
      

      search: '',
      headers: [
        {text: '#', value: 'id'},
        {text: 'Aluno', value: 'name'},
        { text: 'E-mail', value: 'email' },
        { text: 'Estado', value: 'state' },
        { text: 'País', value: 'country' },
        { text: 'Idade', value: 'birthdate' },
        //{ text: 'Instituição', value: 'institution' },
        { text: 'Status', value: 'status', align: 'center'},
        { text: 'Formulário', value: 'actions', align: 'center', sortable: false},
      ],

      countries_map:{ 
        brazilian: 'Brasil', 
        argentine: 'Argentina', 
        colombian: 'Colombia', 
        uruguayan: 'Uruguai', 
        paraguayan: 'Paraguai', 
        peru: 'Peru', 
        // other: 'Outro', 
      },

      status_chips_map: {
        fresh: { color: 'primary', title: 'Novo', icon: 'mdi-account-plus' },
        selected_on_hold: { color: 'primary', title: 'Em espera', icon: 'mdi-clock-outline' },
        selected_on_hold_1: { color: 'primary', title: 'Em espera 1', icon: 'mdi-clock-outline' },
        selected_on_hold_2: { color: 'primary', title: 'Em espera 2', icon: 'mdi-clock-outline' },
        selected_on_hold_3: { color: 'primary', title: 'Em espera 3', icon: 'mdi-clock-outline' },
        selected: { color: 'success', title: 'Selecionado', icon: 'mdi-check' },
        rejected: { color: 'error', title: 'Indeferido', icon: 'mdi-cancel' },
        homologated: { color: 'success', title: 'Homologado', icon: 'mdi-star' },
      },
      downloadingPdf: false
    }
  },
  methods: {
    handleCloseDialog(){

      this.dialog = false
    },
    handleSetDoneFormStatus({value, id}){
      this.dialog = false


      this.$emit('doneChangeDoneFormStatus',{value, id})
    },
    downloadPdf(item) {
      const done_form_id = item.id
      if (!done_form_id) {
        this.addNotification({type: 'error', msg: 'ID do formulário não encontrado'})
        return
      }

      this.downloadingPdf = true
      
      Api.DoneForm.downloadPdf(done_form_id)
        .then(response => {
          const file = new Blob([response.data], { type: 'application/pdf' })
          const fileURL = URL.createObjectURL(file)
          const link = document.createElement('a')
          link.href = fileURL
          const candidate_name = item.name?.replace(/\s+/g, '_') || 'candidato'
          link.setAttribute('download', `formulario_inscricao_${candidate_name}_${done_form_id}.pdf`)
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          URL.revokeObjectURL(fileURL)
          this.addNotification({
            type: 'success',
            msg: 'PDF baixado com sucesso!'
          })
        })
        .catch(err => {
          console.error(err)
          this.addNotification({
            type: 'error',
            msg: 'Erro ao baixar PDF. Tente novamente.'
          })
        })
        .finally(() => {
          this.downloadingPdf = false
        })
    },
    doneFormDialog(selected_done_form){
      this.selected_done_form = selected_done_form
      this.dialog = true
    },
    ...mapActions({
      addNotification: 'Notification/add',
    })
  },
  computed: {
    comp_done_forms(){
      if (this.done_forms.length){
        if (['done_selection', 'in_progress', 'done'].includes(this.course.status)){
          return this.done_forms.filter(df=>df.status == 'homologated')
        }
      }
      return this.done_forms
    },
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  watch: {
    data(nv,ov) {
      if (nv){
      } else if (nv == false){
      }
    }
  },
}
</script>

<style scoped>

</style>